export const copyToClipBoard = async (text: string) => {
  // Modern browsers: Use the Clipboard API if available
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
      console.log("Text copied to clipboard");
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  } else {
    // Fallback to manual copy: Select text and trigger a "copy" command
    const textarea = document.createElement("textarea");
    textarea.id = "tempElement";
    textarea.style.height = "0";
    textarea.style.width = "0";
    textarea.style.opacity = "0";
    textarea.innerText = text;
    document.body.appendChild(textarea);
    textarea.select();
    try {
      const successful = document.execCommand("copy");
      if (successful) {
        console.log("Text copied to clipboard");
      } else {
        console.error("Failed to copy text");
      }
    } catch (err) {
      console.error("Failed to copy text: ", err);
    } finally {
      // Make sure to remove the textarea from the DOM after copying
      document.body.removeChild(textarea);
    }
  }
};
